import { render, staticRenderFns } from "./RenameEntryModal.vue?vue&type=template&id=0a1f95b9"
import script from "./RenameEntryModal.vue?vue&type=script&lang=js"
export * from "./RenameEntryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports